import React from 'react';
import PropTypes from 'prop-types';
import { maxBy } from 'lodash';
import moment from 'moment';
import dateFormat from '../../../utils/dateFormat';
import ResultsPaginator from './ResultsPaginator';

const scheduleTypes = {
  ab: 'Schedule A/B',
  a: 'Schedule A',
  b: 'Schedule B',
  d: 'Schedule D',
  ef: 'Schedule E/F',
  e: 'Schedule E',
  f: 'Schedule F',
  top20: 'Top Twenty',
};

const ScheduleResults = ({ data, filter, onSearch, onGetPetitionPdf }) => {
  const onPetitionClick = (event, row) => {
    event.preventDefault();
    const params = {
      court_code: row.case_court,
      case_no: row.case_no,
    };
    onGetPetitionPdf(params);
  };

  return (
    <div id="ir-search-search-premium-results">
      <h2>
        Results – {data.num_cases} {data.num_cases > 1 ? 'cases' : 'case'}
      </h2>
      {data.results.map((row, idx) => {
        const case_url = `/rpc/legacy/case-menu-redirect/${row.case_court}/${row.case_no}`;
        const emailedDate = maxBy(Object.values(row.schedules), s =>
          s && s.is_new && s.created ? moment(s.created) : null
        );

        return (
          <div key={idx} className="result-item result-item-case-extended">
            <h3 className="result-item-header">
              {row.case_title}
              {' | '}
              <a href={case_url} title="Go to Case Query Menu" target="_blank">
                {row.case_no}
              </a>
              {' | '}
              {row.case_court}
              {' | '}
              Chp. {row.case_chapter}
              {' | '}
              {row.date_filed || row.date_closed}
              {' | '}
              Schedules
            </h3>
            <div className="result-item-section result-item-body">
              <span className="result-case-extended-info">
                <h4>Assets: </h4>
                {row.assets}
              </span>
              <span className="result-case-extended-info">
                <h4>Liabilities: </h4>
                {row.liabilities}
              </span>
              <span className="result-case-extended-info">
                <h4>Industry: </h4>
                {row.industry || 'Unknown'}
              </span>
            </div>
            <div className="result-item-section result-item-case-schedules">
              <a href="#" className="schedule-link" onClick={e => onPetitionClick(e, row)}>
                Petition
              </a>
              {Object.keys(scheduleTypes).map(type => {
                return !row.schedules[type] ? null : (
                  <a
                    href={row.schedules[type].url}
                    className={`schedule-link ${row.schedules[type].is_new ? 'new' : ''}`}
                  >
                    {scheduleTypes[type]}
                  </a>
                );
              })}
              {emailedDate && emailedDate.created && (
                <span className="email-date">
                  <h4>Emailed:</h4>
                  {dateFormat(emailedDate.created)}
                </span>
              )}
              {/* TODO: update URL */}
              {/* <a
              // href="/attorneys/export-csv/nysbke_171257"
              href="/attorneys/export-csv/"
              className="csv-link"
            >
              Attorneys
            </a> */}
            </div>
          </div>
        );
      })}
      <ResultsPaginator
        totalPages={data.page_count}
        selectedPage={filter.page + 1 || 1}
        onChangePage={page => onSearch({ ...filter, page })}
      />
    </div>
  );
};

ScheduleResults.propTypes = {
  data: PropTypes.any.isRequired,
  filter: PropTypes.object.isRequired,
  onSearch: PropTypes.func.isRequired,
  onGetPetitionPdf: PropTypes.func.isRequired,
};

export default ScheduleResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/ScheduleResults.jsx